// NOTE: This function allow us to get the exact position relative to a parent element. `offset` does not account for padding.
export function relativePosition(element, parent) {
    const elementRect = element.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    return {
        bottom: elementRect.bottom - parentRect.bottom,
        left: elementRect.left - parentRect.left,
        right: elementRect.right - parentRect.right,
        top: elementRect.top - parentRect.top,
    };
}
